<template>
    <div>
      <v-row>
        <v-col
          cols="12"
          md="6">
          <v-card
            flat
            class="mb-6"
            style="border: 2px dashed #e0e0e0; border-radius: 10px;">
            <v-card-text>
              <ValidationProvider 
                name="Kawedanan" 
                rules="required" 
                v-slot="{ errors, valid }">
                <div class="body-2 mb-2">
                  <span class="red--text">*</span>
                  Kawedanan
                  <span class="error--text">
                    (wajib diisi)
                  </span>
                </div>
                
                <v-autocomplete
                  v-model="form.kepaniteraan_id"
                  :items="kepaniteraan"
                  item-text="name"
                  item-value="id"
                  filled
                  dense
                  clearable
                  @click:clear="form.kepaniteraan_id = ''"
                  rounded
                  
                  :color="set_color"
                  hide-details
                  placeholder="Pilih Kawedanan"
                  class="mb-6"
                  :success="form.kepaniteraan_id !== '' && valid"
                  :error-messages="errors"
                  style="border-radius: 10px; width: 90;"
                  >
                  <template v-slot:append-outer>
                    <div v-if="errors.length > 0">
                      <v-tooltip top color="#ff5252">
                        <template v-slot:activator="{ on }">
                          <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                        </template>
                        
                        Kawedanan {{ errors[0] }}
                      </v-tooltip>
                    </div>
                    <div v-if="form.kepaniteraan_id !== '' && valid">
                      <v-icon color="success">mdi-check-circle-outline</v-icon>
                    </div>
                  </template>
                </v-autocomplete>
              </ValidationProvider>

              <!-- <div v-if="form.kepaniteraan_id !== '' && form.kepaniteraan_id !== null" class="black--text">
                Nomor Surat Terakhir <span class="pl-2">: {{ kepaniteraan.filter(item => form.kepaniteraan_id).map(item => item)[0].last_undangan_number === '' ? 'Belum ada nomor terakhir' : kepaniteraan.filter(item => form.kepaniteraan_id).map(item => item)[0].last_undangan_number }}</span>
              </div> -->

              <ValidationProvider 
                name="Nomor Surat" 
                rules="required" 
                v-slot="{ errors, valid }">
                <div class="body-2 mb-2">
                  <span class="red--text">*</span>
                  Nomor Surat
                  <span class="error--text pr-2">
                    (wajib diisi)
                  </span>
                  <span v-if="form.kepaniteraan_id !== '' && form.kepaniteraan_id !== null" class="">
                    Nomor Surat Terakhir <span class="pl-1">: {{ kepaniteraan.filter(item => form.kepaniteraan_id).map(item => item)[0].last_undangan_number === '' ? '-' : kepaniteraan.filter(item => form.kepaniteraan_id).map(item => item)[0].last_undangan_number }}</span>
                  </span>
                </div>
                
                <v-text-field
                  filled
                  rounded
                  dense
                  :color="set_color"
                  
                  placeholder="Nomor Surat"
                  hide-details
  
                  v-model="form.number"
                  :success="valid"
                  :error-messages="errors"
                  required
                  class="mb-6"
                  style="border-radius: 10px;">
                  <template v-slot:append-outer>
                    <div v-if="errors.length > 0">
                      <v-tooltip top color="#ff5252">
                        <template v-slot:activator="{ on }">
                          <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                        </template>
                        
                        Nomor Surat {{ errors[0] }}
                      </v-tooltip>
                    </div>
  
                    <div v-if="form.number !== '' && valid">
                      <v-icon color="success">mdi-check-circle-outline</v-icon>
                    </div>
                  </template>
                </v-text-field>
              </ValidationProvider>
            </v-card-text>
          </v-card>
  
          <!-- <ValidationProvider 
            name="Nama File" 
            rules="required" 
            v-slot="{ errors, valid }">
            <div class="body-2 mb-2">
              <span class="red--text">*</span>
              Nama File
              <span class="error--text">
                (wajib diisi)
              </span>
            </div>
            
            <v-text-field
              filled
              rounded
              dense
              :color="set_color"
              
              placeholder="Contoh. Surat Menyurat"
              hide-details
  
              v-model="form.title"
              :success="valid"
              :error-messages="errors"
              required
              class="mb-6"
              style="border-radius: 10px;">
              <template v-slot:append-outer>
                <div v-if="errors.length > 0">
                  <v-tooltip top color="#ff5252">
                    <template v-slot:activator="{ on }">
                      <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                    </template>
                    
                    Nama File {{ errors[0] }}
                  </v-tooltip>
                </div>
  
                <div v-if="form.title !== '' && valid">
                  <v-icon color="success">mdi-check-circle-outline</v-icon>
                </div>
              </template>
            </v-text-field>
          </ValidationProvider>
  
          <ValidationProvider 
            name="Nomor" 
            rules="required" 
            v-slot="{ errors, valid }">
            <div class="body-2 mb-2">
              <span class="red--text">*</span>
              Nomor
              <span class="error--text">
                (wajib diisi)
              </span>
            </div>
            
            <v-text-field
              filled
              rounded
              dense
              :color="set_color"
              
              placeholder="Contoh. 148/05/VII/24/PNT"
              hide-details
  
              v-model="form.meta_json_object.nomor"
              :success="valid"
              :error-messages="errors"
              required
              class="mb-6"
              style="border-radius: 10px; width: 70%;">
              <template v-slot:append-outer>
                <div v-if="errors.length > 0">
                  <v-tooltip top color="#ff5252">
                    <template v-slot:activator="{ on }">
                      <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                    </template>
                    
                    Nomor {{ errors[0] }}
                  </v-tooltip>
                </div>
  
                <div v-if="form.meta_json_object.nomor !== '' && valid">
                  <v-icon color="success">mdi-check-circle-outline</v-icon>
                </div>
              </template>
            </v-text-field>
          </ValidationProvider> -->
  
          <ValidationProvider 
            name="Hal" 
            rules="required" 
            v-slot="{ errors, valid }">
            <div class="body-2 mb-2">
              <span class="red--text">*</span>
              Hal
              <span class="error--text">
                (wajib diisi)
              </span>
            </div>
            
            <v-text-field
              filled
              rounded
              dense
              :color="set_color"
              
              placeholder="Contoh. Surat"
              hide-details
  
              v-model="form.meta_json_object.hal"
              :success="valid"
              :error-messages="errors"
              required
              class="mb-6"
              style="border-radius: 10px; width: 70%;">
              <template v-slot:append-outer>
                <div v-if="errors.length > 0">
                  <v-tooltip top color="#ff5252">
                    <template v-slot:activator="{ on }">
                      <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                    </template>
                    
                    Hal {{ errors[0] }}
                  </v-tooltip>
                </div>
  
                <div v-if="form.meta_json_object.hal !== '' && valid">
                  <v-icon color="success">mdi-check-circle-outline</v-icon>
                </div>
              </template>
            </v-text-field>
          </ValidationProvider>
  
          <v-btn
            @click="add_pegawai()"

            color="#444444"
            elevation="0"
            class="text-capitalize white--text mb-4"
            style="border-radius: 10px;">
            Tambah Pegawai Yang Diundang
          </v-btn>

          <div
            v-for="(item, index) in form.for"
            :key="index">
            <v-card
              flat
              class="pa-3 mb-6"
              style="border: 2px dashed #f0f0f0; border-radius: 10px;">
              <v-btn
                @click="form.for.splice(index, 1)"

                icon
                style="position: absolute; top: -15px; right: -15px;">
                <v-icon
                  color="red">
                  mdi-close-circle
                </v-icon>
              </v-btn>
              <v-radio-group
                v-model="item.option"
                row
                class="mt-0"
                :color="set_color"
                v-on:change="item.name = ''"
              >
                <v-radio
                  value="pegawai"
                  :color="set_color"
                >
                  <template v-slot:label>
                    <div>
                      User Pakualaman
                    </div>
                  </template>
                </v-radio>
                <v-radio
                  value="input"
                  :color="set_color"
                >
                  <template v-slot:label>
                    <div>
                      Non User
                    </div>
                  </template>
                </v-radio>
                <v-radio
                  value="group"
                  :color="set_color"
                >
                  <template v-slot:label>
                    <div>
                      Group
                    </div>
                  </template>
                </v-radio>
              </v-radio-group>

              <div v-if="item.option === 'pegawai'">
                <ValidationProvider 
                  :name="`Nama Yang Diundang ${index + 1}`" 
                  :rules="'required'" 
                  v-slot="{ errors, valid }">
                  <div class="body-2 mb-2">
                    <span class="red--text">*</span>
                    Nama yang Diundang {{ index + 1 }}, Pilih User Pakualaman
                    <span class="error--text">
                      (wajib diisi)
                    </span>
                  </div>

                  <v-autocomplete
                    v-model="item.name"
                    :items="anggota.filter(x => !form.for.map(x => (x.name !== item.name ? x.name : '')).includes(x.name))"  
                    item-text="name"
                    item-value="name"
                    filled
                    dense
                    clearable
                    @click:clear="item.name = ''; item.kalenggahan_name = ''"
                    rounded
                    @input="item.kalenggahan_name = anggota.filter(items => items.name === item.name).map(items => items.kalenggahan_name)[0]"
                    
                    :color="set_color"
                    hide-details
                    placeholder="Pilih User Pakualaman"
                    class="mb-6"
                    :success="item.name !== '' && valid"
                    :error-messages="errors"
                    style="border-radius: 10px; width: 90;"
                  >
                  <template v-slot:append-outer>
                    <div v-if="errors.length > 0">
                      <v-tooltip top color="#ff5252">
                        <template v-slot:activator="{ on }">
                          <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                        </template>
                        
                        Nama yang Diundang {{ index + 1 }}, Pilih User Pakualaman {{ errors[0] }}
                      </v-tooltip>
                    </div>
                    <div v-if="item.name !== '' && valid">
                      <v-icon color="success">mdi-check-circle-outline</v-icon>
                    </div>
                  </template>
                </v-autocomplete>
                </ValidationProvider>
              </div>

              <div v-if="item.option === 'input'">
                <ValidationProvider 
                  :name="`Nama Yang Diundang ${index + 1}`" 
                  rules="required" 
                  v-slot="{ errors, valid }">
                  <div class="body-2 mb-2">
                    <span class="red--text">*</span>
                    Nama Yang Diundang {{ index + 1 }}
                    <span class="error--text">
                      (wajib diisi)
                    </span>
                  </div>
                  
                  <v-text-field
                    filled
                    rounded
                    dense
                    :color="set_color"
                    
                    placeholder="Contoh. John Doe"
                    hide-details
  
                    v-model="item.name"
                    :success="valid"
                    :error-messages="errors"
                    required
                    class="mb-6"
                    style="border-radius: 10px;">
                    <template v-slot:append-outer>
                      <div v-if="errors.length > 0">
                        <v-tooltip top color="#ff5252">
                          <template v-slot:activator="{ on }">
                            <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                          </template>
                          
                          Nama Yang Diundang {{ index + 1 }} {{ errors[0] }}
                        </v-tooltip>
                      </div>
  
                      <div v-if="item.name !== '' && valid">
                        <v-icon color="success">mdi-check-circle-outline</v-icon>
                      </div>
                    </template>
                  </v-text-field>
                </ValidationProvider>
              </div>

              <div v-if="item.option === 'group'">
                <ValidationProvider 
                  :name="`Nama Group ${index + 1}`" 
                  rules="required" 
                  v-slot="{ errors, valid }">
                  <div class="body-2 mb-2">
                    <span class="red--text">*</span>
                    Nama Group {{ index + 1 }}
                    <span class="error--text">
                      (wajib diisi)
                    </span>
                  </div>
                  
                  <v-autocomplete
                    v-model="item.name"
                    :items="group.filter(x => !form.for.map(x => (x.name !== item.name ? x.name : '')).includes(x.name))"  
                    item-text="name"
                    item-value="name"
                    filled
                    dense
                    clearable
                    @click:clear="item.name = ''; item.kalenggahan_name = ''"
                    rounded
                    @input="item.kalenggahan_name = `Group ${item.name}`; item.users= group_user.filter(items => items.grup_name === item.name).map(items => { return { name: items.contact_name, kalenggahan_name: items.contact_kalenggahan_name } })"
                    
                    :color="set_color"
                    hide-details
                    placeholder="Pilih Group"
                    class="mb-6"
                    :success="item.name !== '' && valid"
                    :error-messages="errors"
                    style="border-radius: 10px; width: 90;"
                  >
                    <template v-slot:append-outer>
                      <div v-if="errors.length > 0">
                        <v-tooltip top color="#ff5252">
                          <template v-slot:activator="{ on }">
                            <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                          </template>
                          
                          Nama Group {{ index + 1 }} {{ errors[0] }}
                        </v-tooltip>
                      </div>
                      <div v-if="item.name !== '' && valid">
                        <v-icon color="success">mdi-check-circle-outline</v-icon>
                      </div>
                    </template>
                  </v-autocomplete>
                </ValidationProvider>
              </div>

              <div v-if="item.option !== 'group'">
                <ValidationProvider 
                  :name="`Kalenggahan ${index + 1}`" 
                  :rules="''" 
                  v-slot="{ errors, valid }">
                  <div class="body-2 mb-2">
                    <!-- <span class="red--text">*</span> -->
                    Kalenggahan {{ index + 1 }}
                    <!-- <span class="error--text">
                      (wajib diisi)
                    </span> -->
                  </div>
                  
                  <v-text-field
                    filled
                    rounded
                    dense
                    :color="set_color"
                    
                    placeholder="Contoh. RADEN MAS NGABEI"
                    hide-details
                    :readonly="item.option === 'pegawai'"
    
                    v-model="item.kalenggahan_name"
                    :success="valid"
                    :error-messages="errors"
                    required
                    class="mb-6"
                    style="border-radius: 10px;">
                    <template v-slot:append-outer>
                      <div v-if="errors.length > 0">
                        <v-tooltip top color="#ff5252">
                          <template v-slot:activator="{ on }">
                            <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                          </template>
                          
                          Kalenggahan {{ index + 1 }} {{ errors[0] }}
                        </v-tooltip>
                      </div>
    
                      <div v-if="item.kalenggahan_name !== '' && valid">
                        <v-icon color="success">mdi-check-circle-outline</v-icon>
                      </div>
                    </template>
                  </v-text-field>
                </ValidationProvider>
              </div>

              <div v-if="item.option === 'group'">
                <ol>
                  <li v-for="(user, index) in item.users" :key="index">
                    <div>
                      {{ user.name }} - {{ user.kalenggahan_name === '' ? 'Belum ada kalenggahan' : user.kalenggahan_name }}
                    </div>
                  </li>
                </ol>
              </div>

            </v-card>
          </div>

          <div class="body-2 mb-2">
            Template Undangan
          </div>

          <v-autocomplete
            v-model="template_name"
            :items="template"
            item-text="name"
            item-value="name"
            filled
            dense
            clearable
            return-object
            v-on:change="form.meta_json_object.content = template_name.content"
            @click:clear="template_name = {}"
            rounded
            
            :color="set_color"
            hide-details
            placeholder="Template Undanga"
            class="mb-6"
            style="border-radius: 10px; width: 90;"
          >
          </v-autocomplete>

          <div class="body-2 mb-2">
            <span class="red--text">*</span>
            Isi Surat
            <span class="error--text">
              (wajib diisi)
            </span>
          </div>

          <quill-editor 
            ref="myTextEditor"
            :options="{
              placeholder: 'Isi Surat'
            }"
            class="mb-2"
            v-model="form.meta_json_object.content">
          </quill-editor>
  
          <div>
            <div class="body-2 mb-2">
              <span class="red--text">*</span>
              Tanggal
              <span class="error--text">
                (wajib diisi)
              </span>
            </div>
  
            <v-menu
              ref="tanggal"
              min-width="290px"
              max-width="290px"
              transition="scale-transition"
              offset-y
              :nudge-right="40"
              :close-on-content-click="false"
              v-model="picker.tanggal">
              <template v-slot:activator="{ on, attrs }">
                <ValidationProvider 
                  name="Tanggal" 
                  rules="required"
                  v-slot="{ errors, valid }">
                  <v-text-field
                    readonly
                    filled
                    rounded
                    dense
                    :color="set_color"
                    placeholder="Pilih Tanggal"
                    hide-details
                    clearable
  
                    @click:clear="form.meta_json_object.tanggal = null;"
                    v-on="on"
                    v-bind="attrs"
  
                    v-model="form.meta_json_object.tanggal"
                    :success="form.meta_json_object.tanggal !== null && valid"
                    :error-messages="errors"
                    class="mb-6"
                    style="border-radius: 10px; width: 40%;">
                    <template v-slot:append-outer>
                      <div v-if="errors.length > 0">
                        <v-tooltip top color="#ff5252">
                          <template v-slot:activator="{ on }">
                            <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                          </template>
                          
                          Tanggal {{ errors[0] }}
                        </v-tooltip>
                      </div>
  
                      <div v-if="form.meta_json_object.tanggal !== null && valid">
                        <v-icon color="success">mdi-check-circle-outline</v-icon>
                      </div>
                    </template>
                  </v-text-field>
                </ValidationProvider>
              </template>
  
              <v-date-picker 
                :color="set_color"
                v-model="form.meta_json_object.tanggal"
                @input="picker.tanggal = false">
              </v-date-picker>
            </v-menu>
          </div>
  
          <ValidationProvider 
            name="Nama Yang Bertandatangan" 
            rules="required" 
            v-slot="{ errors, valid }">
            <div class="body-2 mb-2">
              <span class="red--text">*</span>
              Nama Yang Bertandatangan
              <span class="error--text">
                (wajib diisi)
              </span>
            </div>
            
            <v-text-field
              filled
              rounded
              dense
              :color="set_color"
              
              placeholder="Contoh. Nama Penandatangan"
              hide-details
  
              v-model="form.meta_json_object.nama_penandatangan"
              :success="valid"
              :error-messages="errors"
              required
              class="mb-6"
              style="border-radius: 10px;">
              <template v-slot:append-outer>
                <div v-if="errors.length > 0">
                  <v-tooltip top color="#ff5252">
                    <template v-slot:activator="{ on }">
                      <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                    </template>
                    
                    Nama Yang Bertandatangan {{ errors[0] }}
                  </v-tooltip>
                </div>
  
                <div v-if="form.meta_json_object.nama_penandatangan !== '' && valid">
                  <v-icon color="success">mdi-check-circle-outline</v-icon>
                </div>
              </template>
            </v-text-field>
          </ValidationProvider>
  
          <ValidationProvider 
            name="Jabatan Yang Bertandatangan" 
            rules="required" 
            v-slot="{ errors, valid }">
            <div class="body-2 mb-2">
              <span class="red--text">*</span>
              Jabatan Yang Bertandatangan
              <span class="error--text">
                (wajib diisi)
              </span>
            </div>
            
            <v-text-field
              filled
              rounded
              dense
              :color="set_color"
              
              placeholder="Contoh. Penghageng"
              hide-details
  
              v-model="form.meta_json_object.jabatan_penandatangan"
              :success="valid"
              :error-messages="errors"
              required
              class="mb-3"
              style="border-radius: 10px;">
              <template v-slot:append-outer>
                <div v-if="errors.length > 0">
                  <v-tooltip top color="#ff5252">
                    <template v-slot:activator="{ on }">
                      <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                    </template>
                    
                    Jabatan Yang Bertandatangan {{ errors[0] }}
                  </v-tooltip>
                </div>
  
                <div v-if="form.meta_json_object.jabatan_penandatangan !== '' && valid">
                  <v-icon color="success">mdi-check-circle-outline</v-icon>
                </div>
              </template>
            </v-text-field>
          </ValidationProvider>

          <div
            class="mb-6">
            <div class="body-2 mb-2">
              Gambar Ttd
            </div>

            <uploadfolder
              v-model="upload.folder" 
              style="height: 150px; width: 150px">
              <div 
                slot="activator"
                class="cursor-pointer">
                <v-card 
                  flat
                  height="150"
                  width="150"
                  class="d-flex align-center justify-center"
                  style="border-radius: 15px;
                        border: 2px solid #eaeaea; 
                        border-style: dashed;">
                  <v-btn
                    @click="form.meta_json_object.image_ttd = ''"
                    v-if="form.meta_json_object.image_ttd.length > 0"
                    icon
                    style="position: absolute; top: -15px; right: -15px;">
                    <v-icon
                      color="red">
                      mdi-close-circle
                    </v-icon>
                  </v-btn>
                  <div v-if="form.meta_json_object.image_ttd.length < 1">
                    <v-icon v-if="!process.image_footer"
                      size="60" 
                      color="grey">
                      mdi-cloud-upload-outline
                    </v-icon>

                    <v-progress-circular v-else
                      indeterminate
                      :color="set_color">
                    </v-progress-circular>
                  </div>

                  <v-img v-else
                    contain
                    height="150"
                    width="150"
                    :src="form.meta_json_object.image_ttd" 
                    :alt="form.meta_json_object.image_ttd"
                    class="text-center d-flex align-center">
                    <div 
                      class="d-flex align-center justify-center" 
                      style="width: 100%; height: auto;">
                      <v-icon v-if="!process.image_footer"
                        size="60" 
                        color="grey">
                        mdi-cloud-upload-outline
                      </v-icon>

                      <v-progress-circular v-else
                        indeterminate
                        :color="set_color">
                      </v-progress-circular>
                    </div>
                  </v-img>
                </v-card>
              </div>
            </uploadfolder>
          </div>
        </v-col>
  
        <v-col
          cols="12"
          md="6">
          <v-card
            flat
            style="border: 2px solid #f0f0f0; border-radius: 10px; position: sticky; top: 12px;">
            <div
              ref="arsippdf"
              style="padding: 50px;">
              <v-card-text
                class="black--text py-2">
                <v-row>
                  <v-col
                    cols="12"
                    md="7" style="padding-bottom: 0px;">
                    <v-row>
                      <v-col
                        cols="12"
                        md="4"
                        class="py-0"
                        style="padding-top: 0px !important; padding-bottom: 0px !important;">
                        Nomor
                      </v-col>
  
                      <v-col
                        cols="12"
                        md="8"
                        class="py-0"
                        style="padding-top: 0px !important; padding-bottom: 0px !important;">
                        : {{ form.number !== '' ? form.number : '__________' }}
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col
                    cols="12"
                    md="5"
                    style="text-align: center !important; padding-left: 0px; padding-right: 0px; padding-bottom: 0px;">
                    <div>
                      Yogyakarta, {{ form.meta_json_object.tanggal | fulldate }}
                    </div>
                  </v-col>
                  <v-col
                    cols="12"
                    md="12" style="padding-top: 0px;">

                    <v-row>
                      <v-col
                        cols="12"
                        md="2"
                        class="py-0"
                        style="padding-top: 0px !important; padding-bottom: 0px !important;">
                        Hal
                      </v-col>
  
                      <v-col
                        cols="12"
                        md="10"
                        class="py-0"
                        style="padding-top: 0px !important; padding-bottom: 0px !important; padding-left: 26px;">
                        : <span style="font-weight: 700;">{{ form.meta_json_object.hal !== '' ? form.meta_json_object.hal : '__________' }}</span>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col
                    cols="12"
                    md="7">
                  </v-col>
                  <v-col
                    cols="12"
                    md="5">
                    <div
                      class="mt-6"
                      style="margin-top: 24px !important;">
                      <div
                        style="margin-bottom: 1px;">
                        Kepada 
                      </div>
      
                      <div
                        style="margin-bottom: 1px;" >
                        Yth. 
                        <span v-for="(item, index) in form.for" :key="index">
                          {{ item.kalenggahan_name !== '' ? item.kalenggahan_name : item.name !== '' ? item.name : '__________' }} <span v-if="index !== form.for.length - 1">,</span>
                        </span>
                      </div>
      
                      <div
                        style="margin-bottom: 1px;">
                        di Yogyakarta
                      </div>
                    </div>
                  </v-col>
                </v-row>
  
  
                <div
                  class="mt-10"
                  style="margin-top: 40px !important;">
                  <div>
                    <div class="ql-editor" v-html="form.meta_json_object.content"></div>
                  </div>
                </div>
  
                <v-row
                  justify="end"
                  class="mt-8"
                  style="display: flex; flex-wrap: wrap; flex: 1 1 auto; justify-content: flex-end !important; margin-top: 32px !important;">
                  <v-col
                    cols="12"
                    md="6"
                    class="text-center"
                    style="text-align: center !important;">
  
                    <div
                      >
                      {{ form.meta_json_object.jabatan_penandatangan !== '' ? form.meta_json_object.jabatan_penandatangan : '__________' }}
                    </div>

                    <div v-if="form.meta_json_object.image_ttd === ''" style="margin-bottom: 64px !important;">

                    </div>
                    <div v-else>
                      <v-img
                        contain
                        height="100"
                        width="100"
                        :src="form.meta_json_object.image_ttd" 
                        :alt="form.meta_json_object.image_ttd"
                        class="text-center d-flex align-center"
                        style="margin-left: auto; margin-right: auto; padding-top: 4px; padding-bottom: 4px;">
                      </v-img>
                    </div>
  
                    <div>
                      {{ form.meta_json_object.nama_penandatangan !== '' ? form.meta_json_object.nama_penandatangan : '__________' }}
                    </div>
                  </v-col>
                </v-row>
              </v-card-text>
            </div>
          </v-card>
        </v-col>
      </v-row>
    </div>
  </template>
  
  <script>
    import { get, post, put, destroy } from "@/service/Axios";
    import { TokenService } from "@/service/Storage.Service";
    import axios from "axios";
    import moment, { updateLocale } from "moment"
    import "moment/locale/id"
    import html2pdf from 'html2pdf.js'
import { ValidationProvider } from "vee-validate";
    export default {
      props: {
        form: {
          type: Object,
          default: {}
        },
        anggota: {
          type: Array,
          default: []
        },
        process: {
          type: Object,
          default: {}
        },
        template: {
          type: Array,
          default: []
        },
        kepaniteraan: {
          type: Array,
          default: []
        },
        group: {
          type: Array,
          default: []
        },
        group_user: {
          type: Array,
          default: []
        },
      },
      data () {
        return {
          upload: {
            folder: null,
          },
          template_name: {},
          picker: {
            expired: false,
            tanggal: false,
            tanggal_mulai: false,
            tanggal_selesai: false,
            tanggal_masuk: false,
  
            range: false
          },
  
          time: {
            pukul: false
          },
        }
      },
      components: {
        uploadfolder: () => import(/* webpackPrefetch: true */ '@/components/upload/folder.vue'),
      },
      watch: {
        'upload.folder': {
        handler: function () {
          if (this.upload.folder) {
            this.process.image = this.upload.folder.process

            if (!this.process.image) {
              // CALLBACK FROM UPLOAD DOC
              
              this.form.meta_json_object.image_ttd = this.upload.folder.fileuri
            }
          }
        },
        deep: true
      },
      },
      computed: {
        user () {
          return this.$store.state.user
        },
        
        set_color () {
          return this.$store.state.color
        },
        set_color_rgb_soft () {
          let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))
  
          return `rgba(${r}, ${g}, ${b}, 0.2)`
        },
        set_color_rgb () {
          let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))
  
          return `rgba(${r}, ${g}, ${b}, 0.2)`
        },
  
        configHeaders () {
          return this.headers.filter(header => !header.hide)  
        },
  
        // formattedDate: {
        //   get () {
        //     return (this.form.meta_json_object.tanggal && this.form.meta_json_object.tanggal.length === 10) ? moment(this.form.meta_json_object.tanggal).format('DD MMMM YYYY') : this.form.meta_json_object.tanggal
        //   },
        //   set (newValue) {
        //     if (newValue && newValue.length == 10) {
        //         let newDate = `${newValue.substring(6, 10)}-${newValue.substring(3, 5)}-${newValue.substring(0, 2)}`
        //         this.form.meta_json_object.tanggal = newDate
        //     }
        //   }
        // },
  
        date_range () {
          return this.filter.dates.join(' s/d ')
        }
      },
      mounted () {
        
      },
      methods: {
        add_pegawai () {
          this.form.for.push({
            option: 'pegawai',
            name: '',
            kalenggahan_name: '',
            users: []
          })
        }
      }
    }
  </script>
  